var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Help", { attrs: { "help-page": _vm.helpPage, theme: _vm.theme } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }